<script>

    import UsersLoginComponent from './component.login.svelte'

    const features = [
        'Control de envíos y guías',
        'Gestión de usuarios y cuentas',
        'Seguimiento de operaciones',
    ]

    const carriers = ['DHL', 'FedEx', 'Estafeta', 'Paquetexpress', '+ más']

</script>

<style>

    .main {
        min-height: 100vh;
        width: 100vw;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        box-sizing: border-box;
        background:
            radial-gradient(circle at top left, rgba(9, 142, 55, 0.08), transparent 42%),
            #f4f5f7;
    }

    .card {
        display: flex;
        width: 100%;
        max-width: 920px;
        min-height: 520px;
        background: #ffffff;
        border: 1px solid var(--border-subtle, #f0f0f0);
        border-radius: var(--radius-card, 12px);
        overflow: hidden;
        box-shadow: 0 12px 48px rgba(9, 142, 55, 0.08), 0 4px 16px rgba(0, 0, 0, 0.04);
    }

    .card-left {
        position: relative;
        width: 380px;
        flex-shrink: 0;
        padding: 40px 36px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: linear-gradient(160deg, #f3fbf6 0%, #ffffff 55%, #fafbfc 100%);
        border-right: 1px solid var(--border-subtle, #f0f0f0);
        overflow: hidden;
    }

    .card-left::before {
        content: '';
        position: absolute;
        top: -60px;
        right: -60px;
        width: 180px;
        height: 180px;
        border-radius: 50%;
        background: rgba(9, 142, 55, 0.08);
        pointer-events: none;
    }

    .card-left-top {
        position: relative;
        z-index: 1;
    }

    .brand-logo {
        display: block;
        max-width: 190px;
        width: 100%;
        height: auto;
        object-fit: contain;
        margin-bottom: 36px;
    }

    .panel-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 5px 10px;
        margin-bottom: 18px;
        border-radius: 999px;
        background: rgba(9, 142, 55, 0.1);
        color: var(--color-primary, #098E37);
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
    }

    .tagline {
        font-size: 24px;
        font-weight: 700;
        line-height: 1.25;
        color: #1a1a1a;
        margin: 0 0 12px;
    }

    .description {
        font-size: 14px;
        line-height: 1.65;
        color: #6b7280;
        margin: 0 0 24px;
    }

    .features {
        list-style: none;
        margin: 0 0 28px;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .feature-item {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 13px;
        color: #3a3a3a;
    }

    .feature-icon {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba(9, 142, 55, 0.12);
        color: var(--color-primary, #098E37);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        flex-shrink: 0;
    }

    .badges {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .badge {
        padding: 5px 12px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 500;
        color: #3D5C3D;
        background: #ffffff;
        border: 1px solid #dcefe3;
    }

    .copyright {
        position: relative;
        z-index: 1;
        margin: 32px 0 0;
        font-size: 11px;
        color: #a0a0a0;
    }

    .card-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 48px 44px;
        background: #ffffff;
    }

    .form-shell {
        width: 100%;
        max-width: 380px;
    }

    @media screen and (max-width: 820px) {
        .main {
            align-items: flex-start;
            padding: 0;
        }

        .card {
            flex-direction: column;
            min-height: 100vh;
            max-width: none;
            border: none;
            border-radius: 0;
            box-shadow: none;
        }

        .card-left {
            width: 100%;
            padding: 28px 24px 24px;
            border-right: none;
            border-bottom: 1px solid var(--border-subtle, #f0f0f0);
        }

        .brand-logo {
            max-width: 160px;
            margin-bottom: 20px;
        }

        .tagline {
            font-size: 20px;
        }

        .features,
        .copyright {
            display: none;
        }

        .card-right {
            padding: 32px 24px 40px;
            align-items: flex-start;
        }
    }

</style>

<div class="main">
    <div class="card">
        <div class="card-left">
            <div class="card-left-top">
                <img src="images/brand.png" alt="Logisbox" class="brand-logo" />
                <span class="panel-badge">
                    <i class="fas fa-shield-alt"></i>
                    Panel administrador
                </span>
                <p class="tagline">Tu plataforma de administración de envíos</p>
                <p class="description">
                    Gestiona envíos, usuarios, cuentas y operaciones logísticas de manera sencilla y eficiente.
                </p>
                <ul class="features">
                    {#each features as feature}
                        <li class="feature-item">
                            <span class="feature-icon"><i class="fas fa-check"></i></span>
                            {feature}
                        </li>
                    {/each}
                </ul>
                <div class="badges">
                    {#each carriers as carrier}
                        <span class="badge">{carrier}</span>
                    {/each}
                </div>
            </div>
            <p class="copyright">© {new Date().getFullYear()} Logisbox. Todos los derechos reservados.</p>
        </div>
        <div class="card-right">
            <div class="form-shell">
                <UsersLoginComponent />
            </div>
        </div>
    </div>
</div>
